module.exports = __webpack_public_path__ + "static/media/musics2.371970d3.jpg";